import React from "react";
import classes from "./index.module.css";
import { Avatar, Typography, Button } from "@mui/material";
import { generateColor, stringAvatar } from "../utilities/commonFunctions";
import { useNavigate } from "react-router-dom";

// Where a notification opens when clicked, from the `data` the backend stores
// on it (services/notificationService.js). null = not clickable.
export const notificationRoute = (item) => {
  const { type, ref_id: refId } = item?.data || {};
  if (type === "expense_added") {
    return refId ? `/expense-approvals?expense=${refId}` : "/expense-approvals";
  }
  return null;
};

const NotificationItem = ({ item, handleMarkAsRead, onOpen }) => {
  const navigate = useNavigate();
  const route = notificationRoute(item);

  const handleOpen = () => {
    if (!route) return;
    if (item.is_seen === false) handleMarkAsRead?.(item._id);
    onOpen?.();
    navigate(route);
  };
  const getTimeDiff = () => {
    const startDate = new Date(item.createdAt);
    const endDate = new Date();

    // Calculate the time difference in milliseconds
    const timeDifference = endDate - startDate;

    // Calculate time difference in minutes, hours, and days
    const minutes = Math.floor(timeDifference / (1000 * 60));
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (minutes < 60) {
      return `${minutes} minutes`;
    } else if (hours < 24) {
      return `${hours} hours`;
    } else {
      return `${days} days`;
    }
  };
  return (
    <div
      className={classes.NotificationItemMainDiv}
      onClick={route ? handleOpen : undefined}
      role={route ? "button" : undefined}
      style={route ? { cursor: "pointer" } : undefined}
    >
      <div>
        {item.from_user_id?.profile_pic ? (
          <Avatar
            alt="Remy Sharp"
            src={`${process.env.REACT_APP_IMAGE_URL}/${item.from_user_id?.profile_pic?.destination}${item.from_user_id?.profile_pic?.filename}`}
            sx={{ width: 32, height: 32 }}
          />
        ) : (
          <Avatar
            {...stringAvatar(item.from_user_id?.name)}
            sx={{
              bgcolor: `${generateColor(item.from_user_id?.name)}`,
              width: 32,
              height: 32,
              fontSize: 13,
              fontWeight: 700,
            }}
          ></Avatar>
        )}
      </div>
      <div style={{ width: "65%" }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: "#0a1f41 !important",
            lineHeight: "20px",
            margin: "0px",
          }}
        >
          {item.subject}
        </Typography>
        <Typography className={classes.notificationMessgeText}>
          {item.message}
        </Typography>
      </div>
      <Typography
        className={`${classes.notificationMessgeText} ${classes.notificationTime}`}
      >{`${getTimeDiff()} Ago`}</Typography>
      {/* {item.is_seen === false && (
        <Button
          variant="text"
          className={`${classes.TooltipmarkText} ${classes.markAsReadBtn}`}
          onClick={() => handleMarkAsRead(item._id)}
        >
          Mark as read
        </Button>
      )} */}
      {item.is_seen === false && (
        <Button
          variant="contained"
          className={`${classes.TooltipmarkText} ${classes.NewBtn}`}
          onClick={(e) => {
            e.stopPropagation();
            handleMarkAsRead(item._id);
          }}
        >
          New
        </Button>
      )}
    </div>
  );
};

export default NotificationItem;
